/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Common,
  CreateModelDtoTx,
  DeleteModelDtoTx,
  GetDetailModelDtoRx,
  GetModelDataDtoRx,
  GetModelDistributorDtoRx,
  GetModelDtoRx,
  GetModelReportDtoRx,
  ModelControllerGetDistributorParams,
  ModelControllerGetModelDuplicateParams,
  ModelControllerGetModelsParams,
  UpdateModelDtoTx,
  UpdateModelReportTx2,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ModelApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerGetModels
   * @summary 모델 목록 조회
   * @request GET:/api/model
   * @secure
   */
  modelControllerGetModels = (query: ModelControllerGetModelsParams, params: RequestParams = {}) =>
    this.request<GetModelDtoRx, any>({
      path: `/api/model`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerCreateModel
   * @summary 모델 등록
   * @request POST:/api/model
   * @secure
   */
  modelControllerCreateModel = (data: CreateModelDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/model`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerDeleteModel
   * @summary 모델 삭제
   * @request DELETE:/api/model
   * @secure
   */
  modelControllerDeleteModel = (data: DeleteModelDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/model`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerGetModelDuplicate
   * @summary 모델명 중복 조회
   * @request GET:/api/model/duplicate
   * @secure
   */
  modelControllerGetModelDuplicate = (query: ModelControllerGetModelDuplicateParams, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/model/duplicate`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerGetDistributor
   * @summary 총판 조회
   * @request GET:/api/model/distributor
   * @secure
   */
  modelControllerGetDistributor = (query: ModelControllerGetDistributorParams, params: RequestParams = {}) =>
    this.request<GetModelDistributorDtoRx, any>({
      path: `/api/model/distributor`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerGetModelData
   * @summary 모델 수정에 필요한 데이터 반환
   * @request GET:/api/model/{id}/update
   * @secure
   */
  modelControllerGetModelData = (id: number, params: RequestParams = {}) =>
    this.request<GetModelDataDtoRx, any>({
      path: `/api/model/${id}/update`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerUpdateModel
   * @summary 모델 수정
   * @request PUT:/api/model/{id}
   * @secure
   */
  modelControllerUpdateModel = (id: number, data: UpdateModelDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/model/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerGetModel
   * @summary 모델 상세 조회
   * @request GET:/api/model/{id}
   * @secure
   */
  modelControllerGetModel = (id: number, params: RequestParams = {}) =>
    this.request<GetDetailModelDtoRx, any>({
      path: `/api/model/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerGetReports
   * @summary 리포트 관리 조회
   * @request GET:/api/model/{id}/reports
   * @secure
   */
  modelControllerGetReports = (id: number, params: RequestParams = {}) =>
    this.request<GetModelReportDtoRx[], any>({
      path: `/api/model/${id}/reports`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Model API
   * @name ModelControllerUpdateReport
   * @summary 리포트 수정
   * @request PUT:/api/model/{id}/report
   * @secure
   */
  modelControllerUpdateReport = (id: number, data: UpdateModelReportTx2[], params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/model/${id}/report`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
